import { render } from "./HeaderPicker.vue?vue&type=template&id=5dbc3edd&scoped=true"
import script from "./HeaderPicker.vue?vue&type=script&lang=js"
export * from "./HeaderPicker.vue?vue&type=script&lang=js"

import "./HeaderPicker.vue?vue&type=style&index=0&id=5dbc3edd&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbc3edd"]])

export default __exports__